// front-end/src/components/block-system/block-configs/block-types/certificate-block.js

export function createCertificateBlock(block, parent) {
    const blockName = block.data_block_name;

    // Используем те же классы что и news-preview
    const certificateItem = document.createElement('div');
    certificateItem.className = 'certificate-block container-fluid'; // Используем класс news-preview
    certificateItem.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        certificateItem.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        certificateItem.setAttribute('data-order', String(block.order));
    } else {
        certificateItem.setAttribute('data-order', '0');
    }

    certificateItem.style.position = 'relative';

    // Разметка полностью идентичная новостям на главной странице
    certificateItem.innerHTML = `
        <div class="row">
            <div class="col-lg-6 news-preview-meta">
                <p class="publication-date" data-content="${blockName}-date" data-global="true" data-type="date"></p>
                <img src="" alt="Certificate Image" data-content="${blockName}-image" data-type="image" data-global="true" 
                     style="width: 100%; max-width: 300px; height: auto; border-radius: 8px; margin-top: 10px;">
            </div>
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-lg-10">
                        <h5 data-content="${blockName}-title" data-global="true"></h5>
                        <p data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                    </div>
                    <div class="col-lg-2">
                        <a href="#" class="news-link" data-content="${blockName}-document" data-type="document" data-global="true">
                            <img src="images/news-button.svg" alt="download-button" class="news-button default">
                            <img src="images/news-button-hover.svg" alt="download-button-hover" class="news-button hover">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `;

    parent.appendChild(certificateItem);
    return certificateItem;
}

export const certificateBlockProps = {
    name: 'certificate-block',
    title: 'Блок сертифіката',
    description: 'Блок для відображення сертифіката з датою, заголовком, описом та зображенням',
    allowedParents: ['certificates-section'],
    contentFields: [
        {name: 'date', type: 'date', label: 'Дата видачі'},
        {name: 'title', type: 'text', label: 'Назва сертифіката'},
        {name: 'description', type: 'textarea', label: 'Опис'},
        {name: 'image', type: 'image', label: 'Зображення сертифіката'},
        {name: 'document', type: 'document', label: 'PDF документ'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview certificate-block-preview">
                <div class="row">
                    <div class="col-6">
                        <p class="date">${data.date || 'Дата'}</p>
                        <div class="image-placeholder" style="width: 100px; height: 60px; background: #eee; border-radius: 4px;"></div>
                    </div>
                    <div class="col-6">
                        <h5>${data.title || 'Назва сертифіката'}</h5>
                        <p>${data.description || 'Опис сертифіката...'}</p>
                    </div>
                </div>
            </div>
        `;
    }
};